import React, { useEffect, useRef, useState } from "react";
import InputComponent from "../../../components/shared/input/InputComponent";
import style from "./NewReferal.module.scss";
import PhoneInputComponent from "../../../components/shared/input-phone-component/PhoneInputComponent";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import { CitiesDataType } from "../../../interface/site.interface";
import CheckBoxSelected from "../../../components/shared/checkBoxSelected/CheckBoxSelected";
import TermsCheckboxIcon from "../.././../assets/images/pages/login/checkBox.svg";
import { ReferalServices } from "../../../services/referal.service";
import { CitiesService } from "../../../services/cities.service";
import MainButton from "../../../components/shared/button/MainButton";
import UserTermsCheckbox from "../../../components/shared/user_terms-checkbox/UserTermsCheckbox";
import CalendarImg from "../../../assets/images/packages/CalendarDots.svg";
import { useSite } from "../../../context/TranslationContext";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import CustomCheckbox from "../../../components/shared/checkBox/CheckBox";
import SmsCheckboxIcon from "../../../assets/images/pages/login/checkboxMessage.svg";

const NewReferalAccount = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    surname: "",
    email: "",
    birthday: "",
    phone1: "",
    city: "",
    address1: "",
    passport_series: "",
    passport_number: "",
    passport_fin: "",
    gender: "",
    password: "",
    language: "",
    agreement: false,
    citizenship: "",
    password_confirmation: "",
    notSendSms: false,
    comment: "",
    phone_prefix: "50",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { data } = useSelector((state: RootState) => state.translationData);
  const dispatch = useDispatch<AppDispatch>();

  const [phoneCode, setPhoneCode] = useState("50");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSelectChange = (name: string, value: string | number) => {
    console.log(value);

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const [cities, setCities] = useState<CitiesDataType[]>([]);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowConfrimPassword, setIsShowConfrimPassword] = useState(false);

  useEffect(() => {
    CitiesService.getAllCities().then((response) => {
      if (response.status === 200) {
        setCities(response?.data?.original);
      }
    });
  }, [language]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    let newErrors: { [key: string]: string } = {};
    if (!formValues.agreement) {
      newErrors.agreement = `${data?.user_agreement_required}`;
    }
    const payload = {
      ...formValues,
      phone1: formValues.phone1,
      phone_prefix: phoneCode,
    };
    try {
      const response = await ReferalServices.PostNewReferal(payload);
      toast.success(data?.account_created);
      setFormValues({
        name: "",
        surname: "",
        email: "",
        birthday: "",
        phone1: "",
        city: "",
        address1: "",
        passport_series: "",
        passport_number: "",
        passport_fin: "",
        gender: "",
        password: "",
        language: "",
        agreement: false,
        citizenship: "",
        password_confirmation: "",
        notSendSms: true,
        comment: "",
        phone_prefix: "50",
      });
      setPhoneCode("");
      setErrors({});
    } catch (error: any) {
      const backendErrors = error?.content;

      setErrors({ ...newErrors, ...backendErrors });
    } finally {
      setIsSubmitting(false);
    }
  };
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  const [passportSeriesOptions, setPassportSeriesOptions] = useState([
    { value: "", label: `${data?.auth_courier_select}` },
    { value: "AA", label: "AA" },
    { value: "AZE", label: "AZE" },
    { value: "MYI", label: "MYI" },
    { value: "DYI", label: "DYI" },
  ]);

  useEffect(() => {
    if (formValues.citizenship === "1") {
      setPassportSeriesOptions([
        { value: "", label: `${data?.auth_courier_select}` },
        { value: "AA", label: "AA" },
        { value: "AZE", label: "AZE" },
      ]);
    } else if (formValues.citizenship === "2") {
      setPassportSeriesOptions([
        { value: "", label: `${data?.auth_courier_select}` },
        { value: "MYI", label: "MYI" },
        { value: "DYI", label: "DYI" },
      ]);
    }

    setFormValues((prev) => ({ ...prev, passport_series: "" }));
  }, [formValues.citizenship]);

  return (
    <form onSubmit={handleSubmit} className={style.newReferalForm}>
      <div className={style.formRow}>
        <InputComponent
          label={data?.auth_referal_first_name}
          type="text"
          name="name"
          placeholder={data?.auth_referal_first_name}
          value={formValues.name}
          onChange={handleInputChange}
          error={errors.name}
        />
        <InputComponent
          label={data?.auth_referal_last_name}
          type="text"
          name="surname"
          placeholder={data?.auth_referal_last_name}
          value={formValues.surname}
          onChange={handleInputChange}
          error={errors.surname}
        />
        <InputComponent
          label={data?.auth_referal_email}
          type="email"
          name="email"
          placeholder={data?.auth_referal_email}
          value={formValues.email}
          onChange={handleInputChange}
          error={errors.email}
          autoComplete
        />

        {/* <InputComponent
          label="Doğum tarixi"
          type="date"
          name="birthday"
          placeholder=""
          value={formValues.birthday}
          onChange={handleInputChange}
          error={errors.name}
        /> */}

        {/* ///// */}

        <div
          className={style.dateinputWrapper}
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className={style.dateinputWrapper}
            style={{ width: "100%", marginTop: "5px" }}
          >
            {data?.auth_referal_birth_date}
            <div className={style.dateInputWrapper}>
              <InputComponent
                label=""
                type="date"
                name="birthday"
                placeholder={data?.auth_referal_date}
                value={formValues.birthday}
                onChange={handleInputChange}
                // error={errors.birthday}
              />
            </div>
            <p className={style.errorMsg}> {errors.birthday}</p>
          </div>
        </div>

        {/* <PhoneInputComponent
          label={data?.auth_referal_phone_number}
          id="phone1"
          name="phone1"
          placeholder="0000000"
          value={formValues.phone1}
          onChange={(e) => {
            setFormValues((prevValues) => ({
              ...prevValues,
              phone1: e.target.value,
            }));
            
            setErrors({
              ...errors,
              phone1: "",
            });
          }}
          onCodeChange={(code) => setPhoneCode(code)}
          error={errors.phone1}
          combinePrefixWithNumber={false}
        /> */}

        <PhoneInputComponent
          label={data?.auth_common_additional_phone}
          id="phone2"
          name="phone2"
          placeholder="0000000"
          value={formValues.phone1}
          selectedCode={formValues.phone_prefix || "50"}
          onChange={(e) => {
            setFormValues((prev) => ({ ...prev, phone1: e.target.value }));
          }}
          onCodeChange={(code) => {
            setFormValues((prev) => ({ ...prev, phone_prefix: code }));
          }}
          error={errors?.phone1}
        />

        <SelectComponent
          label={data?.auth_referal_city}
          name="city"
          options={[
            { value: "", label: `${data?.auth_attorney_select}` },
            ...cities.map((city) => ({
              value: city.title,
              label: city.title,
            })),
          ]}
          value={formValues.city}
          onChange={(value) => handleSelectChange("city", value)}
          placeholder={data?.auth_attorney_select}
          error={errors.city}
        />

        <InputComponent
          label={data?.address}
          type="text"
          name="address1"
          placeholder={data?.address}
          value={formValues.address1}
          onChange={handleInputChange}
          error={errors.address1}
        />

        <SelectComponent
          label={data?.auth_common_citizenship}
          name="citizenship"
          options={[
            { value: "", label: `${data?.auth_attorney_select}` },
            { value: "1", label: `${data?.azerbaijani}` },
            { value: "2", label: `${data?.foreign_citizen}` },
          ]}
          value={formValues.citizenship}
          onChange={(value) => handleSelectChange("citizenship", value)}
          placeholder={data?.auth_attorney_select}
          error={errors.citizenship}
        />

        <div style={{ display: "flex", gap: "10px" }}>
          <SelectComponent
            label={data?.auth_referal_passport_series}
            name="passport_series"
            // options={[
            //   { value: 1, label: "AA" },
            //   { value: 2, label: "AZE" },
            //   { value: 3, label: "MYI" },
            //   { value: 4, label: "DYI" },
            // ]}
            options={passportSeriesOptions}
            value={formValues.passport_series}
            onChange={(value) => handleSelectChange("passport_series", value)}
            placeholder={data?.auth_attorney_select}
            error={errors.passport_series}
            disabled={!formValues.citizenship}
          />
          <InputComponent
            label={data?.auth_referal_passport_number}
            type="text"
            name="passport_number"
            placeholder="0000000"
            value={formValues.passport_number}
            onChange={handleInputChange}
            error={errors.passport_number}
          />
        </div>
        <InputComponent
          label={data?.auth_referal_passport_fin}
          type="text"
          name="passport_fin"
          placeholder={data?.auth_referal_passport_fin}
          value={formValues.passport_fin}
          onChange={handleInputChange}
          error={errors.passport_fin}
        />

        <CheckBoxSelected
          value={formValues.gender}
          error={errors.gender}
          onChange={(value) => handleSelectChange("gender", value)}
        />
        <SelectComponent
          label={data?.auth_referal_language_select}
          name="language"
          options={[
            { value: "", label: `${data?.auth_attorney_select}` },
            { value: "AZ", label: "AZ" },
            { value: "EN", label: "EN" },
            { value: "RU", label: "RU" },
          ]}
          value={formValues.language}
          onChange={(value) => handleSelectChange("language", value)}
          placeholder={data?.auth_attorney_select}
          error={errors.language}
        />
        <InputComponent
          label={data?.auth_referal_password}
          type="password"
          name="password"
          placeholder={data?.auth_referal_password}
          value={formValues.password}
          onChange={handleInputChange}
          isPassword={true}
          isShowPassword={isShowPassword}
          toggleShowPassword={() => setIsShowPassword(!isShowPassword)}
          error={errors.password}
          autoComplete
        />
        <InputComponent
          label={data?.auth_referal_password_repeat}
          type="password"
          placeholder={data?.auth_referal_password_repeat}
          name="password_confirmation"
          value={formValues.password_confirmation}
          onChange={handleInputChange}
          isPassword={true}
          isShowPassword={isShowConfrimPassword}
          toggleShowPassword={() =>
            setIsShowConfrimPassword(!isShowConfrimPassword)
          }
          error={errors.password_confirmation}
          autoComplete
        />
      </div>
      <div
        // className={`${style.numberRow} ${hasError ? style.hasError : ""}`}
        className={style.numberRow}
      >
        <CustomCheckbox
          icon={SmsCheckboxIcon}
          text={data?.auth_common_no_sms_notify}
          color="#36654a"
          checked={formValues.notSendSms}
          onChange={(checked) =>
            setFormValues((prev) => ({
              ...prev,
              notSendSms: checked,
            }))
          }
        />
      </div>
      <div className={style.CheckRow}>
        <UserTermsCheckbox
          icon={TermsCheckboxIcon}
          text=""
          linkText={data?.auth_referal_agree_terms}
          linkHref="https://colibri.az/uploads/static/new_terms_az.pdf"
          color="#f05922"
          checked={formValues.agreement}
          onChange={(checked) =>
            setFormValues((prev) => ({ ...prev, agreement: checked }))
          }
          error={errors.agreement}
        />
        <MainButton
          text={data?.send}
          type="button"
          onClick={handleSubmit}
          disabled={isSubmitting}
        />
      </div>
    </form>
  );
};

export default NewReferalAccount;
